/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Fast_Track_FailedInputs */

const en_directory_submit_enrich_fast_track_failed = /** @type {(inputs: Directory_Submit_Enrich_Fast_Track_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not start Fast Track checkout. Please try again.`)
};

const zh_directory_submit_enrich_fast_track_failed = /** @type {(inputs: Directory_Submit_Enrich_Fast_Track_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法发起 Fast Track 支付，请重试。`)
};

/**
* | output |
* | --- |
* | "Could not start Fast Track checkout. Please try again." |
*
* @param {Directory_Submit_Enrich_Fast_Track_FailedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_fast_track_failed = /** @type {((inputs?: Directory_Submit_Enrich_Fast_Track_FailedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Fast_Track_FailedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_fast_track_failed(inputs)
	return zh_directory_submit_enrich_fast_track_failed(inputs)
});
export { directory_submit_enrich_fast_track_failed as "directory.submit.enrich.fast_track_failed" }